import React from 'react';

import { Trail } from 'react-spring/renderprops';
import { animated } from 'react-spring';

import Card from '../components/Layouts/ContentLayout/CardLayout/Card';

const CatalogueRoll = ({
  cards,
  emptyComponent,
  animationDelay = 0,
  reduceMotion = true,
}) => {
  const AnimatedCard = animated(Card);

  const trailFrom = reduceMotion
    ? { opacity: 0, transform: 'translateX(0) scale(0.95)' }
    : { opacity: 1, transform: 'translateX(-100vw) scale(0.9)' };

  /**
   * Utility function to create array of <Card>
   * @param {{title, subtitle, image, link}[]} cards
   */
  const _getCards = (cards) => {
    return (
      <Trail
        items={cards}
        keys={(card) => card.link || card.title}
        from={trailFrom}
        to={{ opacity: 1, transform: 'translateX(0) scale(1)' }}
        delay={animationDelay}
      >
        {(card) => (props) => {
          return (
            <AnimatedCard
              native
              style={props}
              title={card.title}
              subtitle={card.subtitle}
              image={card.image}
              link={card.link}
              bgColor={card.bgColor}
              textColor={card.textColor}
            ></AnimatedCard>
          );
        }}
      </Trail>
    );
  };

  if (cards && cards.length > 0)
    return <div className="columns is-multiline">{_getCards(cards)}</div>;

  return emptyComponent || null;
};

export default CatalogueRoll;
